// extracted by mini-css-extract-plugin
export var auto = "_40-1";
export var spinner = "_40-0";